module.exports = __webpack_public_path__ + "static/media/Baby---Graphite-and-Pastels.30371c06.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/img/thumbnails/Baby---Graphite-and-Pastels.jpg
 ** module id = 419
 ** module chunks = 0
 **/